var __jsx = React.createElement;
import React, { useCallback } from "react";
import { ELSGrid } from "components/common/elsevier/Grid/Grid";
import Search from "../../shared-components/Search";
import DeleteButton from "../../shared-components/DeleteButton";
import Sections from "./Sections";
import Booleans from "./Booleans";
import Styles from "./Styles.module.scss";
function Fields(_ref) {
  var row = _ref.row,
    first = _ref.first,
    field = _ref.field,
    setField = _ref.setField,
    deleteField = _ref.deleteField;
  var id = field.id,
    _boolean = field["boolean"],
    section = field.section,
    search = field.search;
  var handleOnChangeBoolean = useCallback(function (value) {
    setField("boolean", value);
  }, [setField]);
  var handleOnchangeSection = useCallback(function (value) {
    setField("section", value);
  }, [setField]);
  var handleOnChangeSearch = useCallback(function (value) {
    setField("search", value);
  }, [setField]);
  return /*#__PURE__*/React.createElement(ELSGrid, {
    container: true,
    spacing: "24px",
    className: "".concat(Styles.fields, " ev-search-fields-container")
  }, /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 1.5
  }, !first && /*#__PURE__*/React.createElement(Booleans, {
    className: Styles.fields__boolean,
    name: "boolean-".concat(id),
    "aria-label": "and/or/not row ".concat(row),
    value: _boolean,
    onChange: handleOnChangeBoolean,
    "data-cy": "search-boolean-".concat(row)
  })), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Sections, {
    name: "section-".concat(id),
    "aria-label": "search within row ".concat(row),
    value: section,
    onChange: handleOnchangeSection,
    "data-cy": "search-within-".concat(row)
  })), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Search, {
    name: "search-".concat(id),
    value: search,
    "aria-label": "search input row ".concat(row),
    onChange: handleOnChangeSearch,
    "data-cy": "search-query-".concat(row),
    placeholder: "Search for artificial intelligence",
    required: true
  })), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 1.5
  }, !first && /*#__PURE__*/React.createElement(DeleteButton, {
    name: "delete-".concat(id),
    "aria-label": "delete search fields row ".concat(row),
    onClick: deleteField,
    "data-cy": "delete-search-".concat(row)
  })));
}
export default Fields;